// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 薪人薪事配置表单项
 * @constructor
 */
const XRXSFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "client_id"]}
        label={"client_id"}
        placeholder={"请输入client_id"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入client_id"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "client_secret"]}
        label={"client_secret"}
        placeholder={"请输入client_secret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入client_secret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "grant_type"]}
        label={"grant_type"}
        placeholder={"请输入grant_type"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入grant_type"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.XRXS})
          return _data
        }}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default XRXSFormItems
